module.exports = __webpack_public_path__ + "static/media/5.24fdfb35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/5.jpg
// module id = 166
// module chunks = 0